import { requirePermission } from '@/utils/filter';
import { userStore, appStore } from '@/store';
import { OPERATION_PERMISSIONS } from '@/configs/enums/permissions';
import { baAdminApis } from '@/apis/baAdmin';

/**
 * お支払い設定画面
 */
export const canAccessPaymentCardCreatePlan = async (): Promise<boolean> => {
  // 1. 基本料金課金対象チェック
  if (!userStore.isCompanyChargeTarget) {
    console.error('基本料金課金が無効です');

    return Promise.resolve(false);
  }

  // 2. COMPANY_SETTING_PAYMENT_WRITE 権限チェック
  if (!requirePermission([OPERATION_PERMISSIONS.COMPANY_SETTING_PAYMENT_WRITE])) {
    console.error('COMPANY_SETTING_PAYMENT_WRITE 権限がありません');

    return Promise.resolve(false);
  }

  // 3. 年払い機能ONチェック
  if (!appStore.appConfig.annual_charge_enable) {
    console.error('年払い機能が無効です');

    return Promise.resolve(false);
  }

  // 4. 無料期間チェック
  if (userStore.isFreePeriod) {
    console.error('無料期間です');

    return Promise.resolve(false);
  }

  // 5. 退会予約チェック
  if (userStore.loginUser.company_is_unsubscribed) {
    console.error('退会予約が入っています');

    return Promise.resolve(false);
  }

  // 6: 未収エラーチェック
  try {
    const data = await baAdminApis().getBaAdminChargeErrors();
    if (data.result.list.length > 0) {
      console.error('未収データがあります');

      return Promise.resolve(false);
    }
  } catch (error) {
    console.error('未収データ取得に失敗しました');

    return Promise.resolve(false);
  }

  // 7: 課金開始日時がない場合
  if (!userStore.companyChargeStartAt) {
    console.error('課金開始日時が入っていません');

    return Promise.resolve(false);
  }

  return Promise.resolve(true);
};
